
import React from 'react';
import { motion } from 'framer-motion';
import { techStack } from '../../constants';
import { fadeInUp, staggerChildren } from '../../utils/animations';

const Technologies = () => {
    return (
        <motion.section
            className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0f0f17] relative overflow-hidden"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}>
            {/* Background decoration */}
            <div className="absolute inset-0">
                <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-bl from-[#ff5c35]/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gradient-to-tr from-[#ff5c35]/10 to-transparent"></div>
            </div>

            <div className="max-w-7xl mx-auto relative z-10">
                <motion.div
                    className="text-center mb-16"
                    variants={staggerChildren}
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: true }}>
                    <motion.h2
                        className="text-4xl sm:text-5xl font-bold mb-6"
                        variants={fadeInUp}>
                        Technológiák
                    </motion.h2>
                    <motion.p
                        className="text-gray-400 max-w-2xl mx-auto text-lg mb-6"
                        variants={fadeInUp}>
                        Modern technológiák, amelyekkel álmai weboldala valósággá válik
                    </motion.p>
                    <div className="w-24 h-1 bg-[#ff5c35] mx-auto"></div>
                </motion.div>

                <motion.div
                    className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-8"
                    variants={staggerChildren}
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: true }}>
                    {techStack.map((tech, index) => (
                        <motion.div
                            key={index}
                            className="group relative"
                            variants={fadeInUp}>
                            <div
                                className="absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl"
                                style={{ background: `linear-gradient(to bottom right, ${tech.color})` }}></div>
                            <div className="relative bg-[#1a1a2e] p-4 md:p-8 rounded-xl border border-gray-800/50 group-hover:border-[#ff5c35]/30 transition-all duration-500">
                                <div className="flex flex-col items-center text-center">
                                    <motion.div
                                        className="w-12 h-12 md:w-16 md:h-16 mb-3 md:mb-4 relative flex items-center justify-center"
                                        whileHover={{ scale: 1.1, rotate: 5 }}
                                        transition={{ type: "spring", stiffness: 300 }}>
                                        <img
                                            src={tech.icon}
                                            alt={tech.name}
                                            className="w-9 h-9 md:w-12 md:h-12 object-contain transition-all duration-300 filter group-hover:brightness-110"
                                            loading="lazy"
                                            decoding="async"
                                            width={64}
                                            height={64}
                                        />
                                    </motion.div>
                                    <motion.h3
                                        className="text-sm md:text-lg font-semibold mb-1 md:mb-2 transition-colors duration-300 group-hover:text-[#ff5c35]"
                                        whileHover={{ scale: 1.05 }}>
                                        {tech.name}
                                    </motion.h3>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </motion.section>
    );
};

export default Technologies;
